
var jsonHelper = {

    // 多选

    // 学校性质
    getNature: function () {
        return [
            { id: 1, name: '国立' },
            { id: 2, name: '公立' },
            { id: 3, name: '私立' },
        ];
    },
    // 语言学校性质
    getSchNature: function () {
        return [
            { id: 1, name: '财团法人' },
            { id: 2, name: '学校法人' },
            { id: 3, name: '株式会社' },
            { id: 4, name: '公益法人' },
        ];
    },
    //获取留学时间--月份
    getMonth: function () {
        return [
            {id:1,value:1},
            {id:4,value:4},
            {id:7,value:7},
            {id:10,value:10},
        ]
    },
    // 留学类型
    getTypeList: function () {
        return [
            { id: 1, name: '语言学校' },
            { id: 2, name: '研究生' },
        ]
    },
}

export default jsonHelper;